import React, { useState } from "react";
import { useDropzone } from "react-dropzone";
import {
  Box,
  Typography,
  Button,
  Paper,
  Breadcrumbs,
  CircularProgress,
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Link, useNavigate } from "react-router-dom";
import MainScreen from "../../Components/Navbar/MainScreen";
import axios from "axios";
import AXIOS from "../../Utils/AXIOS";
import { connect } from "react-redux";
import { jsPDF } from "jspdf";
import mammoth from "mammoth";
import toast, { Toaster } from "react-hot-toast";

function UploadFile(props) {
  const [files, setFiles] = useState([]);

  const [loading, setLoading] = useState();
  const onDrop = (acceptedFiles) => {
    // setFiles([...files, ...acceptedFiles]);
    setFiles([...acceptedFiles]);
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    multiple: true,
    accept: "*", // Accept all file types
  });

  const navigate = useNavigate();

  function convertToPDF(file) {
    return new Promise((resolve, reject) => {
      const isPDF =
        file.type === "application/pdf" ||
        file.name.toLowerCase().endsWith(".pdf");

      if (isPDF) {
        resolve(file); // Already a PDF
        return;
      }

      const reader = new FileReader();

      reader.onload = async function (e) {
        const content = e.target.result;
        const pdf = new jsPDF();

        // 📄 Handle .docx files
        if (
          file.type ===
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
          file.name.toLowerCase().endsWith(".docx")
        ) {
          try {
            const result = await mammoth.convertToHtml({
              arrayBuffer: content,
            });
            const text = result.value.replace(/<\/?[^>]+(>|$)/g, ""); // Strip HTML tags
            const lines = pdf.splitTextToSize(text, 180); // Split to fit width
            pdf.text(lines, 10, 10);
            const pdfBlob = pdf.output("blob");
            resolve(pdfBlob);
          } catch (err) {
            reject("Error converting DOCX to PDF: " + err);
          }
        }

        // 📄 Handle text/plain
        else if (file.type === "text/plain") {
          pdf.text(content, 10, 10);
          const pdfBlob = pdf.output("blob");
          resolve(pdfBlob);
        }

        // 🖼️ Handle images
        else if (file.type.startsWith("image/")) {
          const img = new Image();
          img.src = content;

          img.onload = () => {
            pdf.addImage(img, "JPEG", 10, 10, 180, 160);
            const pdfBlob = pdf.output("blob");
            resolve(pdfBlob);
          };

          img.onerror = () => reject("Image loading failed.");
        }

        // ❌ Unsupported types
        else {
          reject("Unsupported file type.");
        }
      };

      // Read file content accordingly
      if (file.name.toLowerCase().endsWith(".docx")) {
        reader.readAsArrayBuffer(file); // DOCX needs ArrayBuffer
      } else if (file.type.startsWith("image/")) {
        reader.readAsDataURL(file);
      } else {
        reader.readAsText(file);
      }
    });
  }
  function blobToFile(blob, fileName) {
    return new File([blob], fileName, { type: blob.type || "application/pdf" });
  }
  const handleFileUpload = () => {
    if (files.length > 0) {
      setLoading(true);

      let formData = new FormData();
      files.forEach(async (file) => {
        if (file) {
          formData.append("file", file);
        }
        //  else if (file && file.type != "application/pdf") {
        //   let changedFile = await convertToPDF(file);
        //   let originalFileName = file.name;
        //   originalFileName = originalFileName.replace(/\.[^/.]+$/, "") + ".pdf";
        //   const pdfFile = blobToFile(changedFile, originalFileName);
        //   console.log("skjahfkjahs", pdfFile);
        //   function downloadFile(file) {
        //     const url = URL.createObjectURL(file);
        //     const a = document.createElement("a");
        //     a.href = url;
        //     a.download = file.name || "download.pdf"; // Set the filename for download
        //     document.body.appendChild(a);
        //     a.click();
        //     document.body.removeChild(a);
        //     URL.revokeObjectURL(url);
        //   }
        //   downloadFile(pdfFile);
        //   formData.append("file", pdfFile);
        // }
      });
      // for (let [key, value] of formData.entries()) {
      //   console.log("hello", key, value);
      // }

      axios
        .post(AXIOS.defaultURL + AXIOS.resume_analytics_upload, formData, {
          headers: {
            Authorization: `Bearer ${props.token}`,
            "x-api-key": `${props.token}`,
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          setLoading(false);

          navigate("/document-interaction", {
            state: {
              FILE: files[0],
              RESPONSE: response.data,
            },
          });
        })
        .catch((err) => {
          setLoading(false);
          // toast.error("Something went wrong");
          if (err.response) {
            console.error("Error Response:", err.response);
          } else if (err.request) {
            console.error("Error Request:", err.request);
          } else {
            console.error("Error Message:", err.message);
          }

          if (err?.response?.status === 403 || err?.response?.status === 401) {
            toast.error("Unauthorized access! Please check your credentials.");
          } else if (err?.message?.includes("Network Error")) {
            toast.error(
              "CORS policy error: Server might be blocking the request."
            );
          } else {
            toast.error("Something went wrong");
          }
        });
    } else {
      toast.error("Please upload a file");
    }
  };

  return (
    <MainScreen>
      <Toaster />
      <Box
        sx={{
          p: 2,
        }}
      >
        {/* <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
          <Link underline="hover" color="inherit" to="/">
            ATS++
          </Link>
          <Typography sx={{ color: "text.primary" }}>
            Upload New File
          </Typography>
        </Breadcrumbs> */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: "#fff",
          }}
        >
          <div
            style={{
              display: "flex",
              // marginTop: 5,
            }}
          >
            <div
              className="gray-arrow-container"
              onClick={() => {
                navigate("/home");
              }}
            >
              True ATS+
            </div>
            <div className="blue-arrow-container">Upload File</div>
          </div>
        </div>
        <Box
          sx={{
            height: "80vh", // Full viewport height
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {/* Breadcrumbs Navigation */}

          {/* Upload Container */}
          <Paper
            elevation={3}
            sx={{
              p: 3,
              textAlign: "center",
              border: "2px dashed #ccc",
              cursor: "pointer",
              backgroundColor: "#fafafa",
              height: "60vh", // Increased height
              width: "40vw", // Responsive width
              minWidth: "300px", // Ensures it doesn’t shrink too much on small screens
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
            {...getRootProps()}
          >
            <input
              {...getInputProps()}
              onChange={(e) => {
                setFiles([e.target.files[0]]);
              }}
            />
            <CloudUploadIcon sx={{ fontSize: 100, color: "#fd815e" }} />
            <Typography variant="h6" sx={{ mt: 1 }}>
              Drag & drop files here, or click to upload
            </Typography>
            {/* <Button variant="contained" sx={{ mt: 2 }}>
              Select Files
            </Button> */}
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#14bc9a",
                color: "#fff",
                "&:hover": {
                  backgroundColor: "#119a80",
                },
              }}
            >
              Select Files
            </Button>

            {/* Show uploaded file names */}
            {files.length > 0 && (
              <Box sx={{ mt: 2, textAlign: "left", width: "100%" }}>
                <Typography
                  variant="subtitle1"
                  style={{
                    backgroundColor: "#14bc9a",
                    color: "#fff",
                    borderRadius: 5,
                    padding: 2,
                  }}
                >
                  Selected Files
                </Typography>
                {files.map((file, index) => (
                  <Typography key={index} variant="body2">
                    📄 {file.name}
                  </Typography>
                ))}
              </Box>
            )}
          </Paper>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#578FCA",
              mt: 2,
              minWidth: 100,
              height: 30,
              color: "#fff",
              "&:hover": {
                backgroundColor: "#578FCA",
              },
            }}
            onClick={() => {
              handleFileUpload();
            }}
          >
            {loading ? (
              <CircularProgress size={"20px"} sx={{ color: "#fff" }} />
            ) : (
              "Submit"
            )}
          </Button>
        </Box>
      </Box>
    </MainScreen>
  );
}

const mapStateToProps = (state) => ({
  token: state.auth.token,
});

export default connect(mapStateToProps)(UploadFile);
